export type UserRole = 'viewer' | 'editor' | 'admin';

export type RoleObject = {
  id: string;
  name?: string;
  title?: string;
};

export const ROLE_HIERARCHY: Record<UserRole, number> = {
  viewer: 1,
  editor: 2,
  admin: 3,
} as const;

export const ROLE_NAME_MAP: Record<string, UserRole> = {
  admin: 'admin',
  editor: 'editor',
  viewer: 'viewer',
} as const;

export const extractRoleType = (roleTitle: string): UserRole | null => {
  const normalized = roleTitle.toLowerCase();
  return ROLE_NAME_MAP[normalized] ?? null;
};

/**
 * Admin / editor / viewer ship with every account and can't be managed like
 * the custom roles an account creates for itself.
 */
export const isBuiltInRole = (roleName: string): boolean =>
  roleName.toLowerCase() in ROLE_NAME_MAP;

export const getUserRole = (
  roles: Array<RoleObject> | undefined,
): UserRole | null => {
  if (!roles || roles.length === 0) return null;

  const firstRole = roles[0];
  const roleIdentifier = firstRole.title;
  if (!roleIdentifier) return null;
  return extractRoleType(roleIdentifier);
};

export const hasRequiredRole = (
  userRole: UserRole | null,
  requiredRole: UserRole,
): boolean => {
  if (!userRole) return false;
  return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[requiredRole];
};
